import { createRemoteComponent } from '@remote-ui/core';

/**
 * Text is used to visually style and provide semantic value for a small piece of text
 * content.
 */
const Text = createRemoteComponent('Text');

export { Text };
